<template>
    <footer class="page-footer">
        <div class="page-content">
            <div class="footer-content-area footer-service-area">
                <div class="footer-title" data-locale="coreTechnology">核心技术</div>
                <ul class="footer-list inline-footer-list">
                    <li><a href="face_detection.html" data-locale="faceCheck">人脸检测</a></li>
                    <li><a href="face_crux.html" data-locale="faceLinchpin">人脸关键点</a></li>
                    <li><a href="face_compare.html" data-locale="faceContrast">人脸对比</a></li>
                    <li><a href="face_attributes.html" data-locale="faceAttribute">人脸属性</a></li>
                    <li><a href="face_retrieve.html" data-locale="faceSearch">人脸搜索</a></li>
                    <li><a href="discernment_age.html" data-locale="ageRecognition">年龄识别</a></li>
                    <li><a href="discernment_clothing.html" data-locale="clothingRecognition">衣着识别</a></li>
                    <li><a href="discernment_gender.html" data-locale="genderRecognition">性别识别</a></li>
                    <li><a href="discernment_licence_plate.html" data-locale="plateNumberRecognition">车牌识别</a></li>
                    <li><a href="discernment_car.html" data-locale="vehicleRecognition">车辆类型</a></li>
                    <li><a href="discernment_id_card.html" data-locale="IDCloudDecipher">身份证云解码</a></li>
                    <li><a href="discernment_cid.html" data-locale="CIDRecognition">CID公民网络身份识别</a></li>
                    <li class="special-footer-list-item"><a href="discernment_passport.html"
                                                            data-locale="passportRecognition">护照、港澳通行证识别</a></li>

                </ul>
            </div>
            <div class="footer-content-area footer-produce-area">
                <div class="footer-title" data-locale="product">产品</div>
                <ul class="footer-list">
                    <li><a href="product_api.html">WEB API</a></li>
                    <li><a href="product_sdk.html">SDK</a></li>
                </ul>
            </div>
            <div class="footer-content-area footer-business-area">
                <div class="footer-title" data-locale="business">业务</div>
                <ul class="footer-list">
                    <li><a href="business.html" data-locale="buildingSystem">搭建智能云系统</a></li>
                    <li><a href="business.html#operation" data-locale="systemOperation">智能云系统运维</a></li>
                </ul>
            </div>
            <div class="footer-content-area footer-sale-area">
                <div class="footer-title" data-locale="beforeAndAfterSales">售前售后</div>
                <ul class="footer-list">
                    <li><span data-locale="preSalePhone">咨询热线(一)</span>：028-85038030</li>
                    <li><span data-locale="preSalePhone">咨询热线(二)</span>：028-82880293</li>
                    <li><a href="openapi.html" data-locale="accessGuide">接入指南</a></li>
                </ul>
            </div>
            <div class="footer-content-area footer-about-area">
                <div class="footer-title" data-locale="about">关于我们</div>
                <ul class="footer-list">
                    <li><a href="https://www.yzfuture.cn" target="_blank" data-locale="companyProfile">公司简介</a></li>
                    <!-- <li><a href="about_us_index.html#laboratory" data-locale="customerCase">客户案例</li> -->
                    <!-- <li><a href="about_us_index.html#connection" data-locale="contactUs">联系我们</li> -->
                </ul>
            </div>

            <div class="clear-line"></div>
            <p class="footer-message" data-locale="WebsiteCopyright">
            <span id="copyright-text" style="margin-right: 10px;">{{copyright}}</span>
                <span class="copyright-item"><a href="http://beian.miit.gov.cn"  style="text-decoration: none;"
                                                target="_blank">蜀ICP备19014280号</a></span>
              <span style="margin-left: 5px">
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002006052" rel="noreferrer" style="text-decoration: none;" target="_blank"><img style="
                display: inline-block;
                width: 15px;
                height: 15px;
                margin-right: 2px;
                margin-bottom: 5px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAFQklEQVRYw+3Wa1BUdRjH8SOpMeg4WhZGpDIxiaaTeUFgWrxE4AVRQJGlRRAVIV1JkbgMgQLi5AVBQSVLSp0xlEAUKBEEFZCrCstll8UV2AV2YbmoGCrYv31+R95UL5pmmtamZ+bz6rz5nvOc/5zDcX9jGLs/iTxuyvIlWYkRFeTHA2HVRFtzfhthTG5KuH96/vUgNlC4mMgyw1NJit/aAXLKazYje9xtIMZ/OZz50gW+9hcNkvoLEemEPbnrSP47QYwxQ5Ifv54RqzcXwFFvSyjaOhfavN8F7Y5ZcC/HH9JOB4LNa9Zw5YA76OZV8vIGMdZtSp7cDrtOnOavYiQhTAiPwi1AMtIQaqyngsxpBtw2GAGDKfaQmpUAa6xc4Vfp4UtEdzAMycsT9JQ1Tyctl/2eEkuTlYysF/rCUNxMqDEzgTqzSXBnpgnIHCzgjvEEuD52DLBr3rA1MAaWmNtB582wdtIljZ9G9D+IPU6aTxIPBjHCcXvg3CEh9K2fDLWvjIH6D6fwTIyheuwEqLUyhzLOALq8pkN+bgRw3HY4FBsMzxojZxP9DequLjAlQwVrbpIjhyIY4UYGQ/buhdBqPxlk3Gion2IMDQIz3kJe/ZS34I7uHkmD7VSQVgYDNyIAwsNCgfXGXoOBPjP9DKrOCAogA2etGTmTHAMcFwFZye7wS5QlVHGjoEw4A2qPCUBZ6AzNcQ5Q/YYRdO+YB1U3dsDwypLio4FJ3ECryIzWz6Cm3NgTRHN8HiPF6eHAGSbAdh8feFZkB7krzaHE9h2o85sDsiAbkIsXQMN+e2CtGyF0kzdwXCgU5++D/ouLQFV4OEU/g2Q/iNuIPNaKkQflAWBqexxGjhLDVUcL6IwSQN3SGVChe6FJg9dckCx6D1QBliDZLIAxo7eA8eyv4KE0BJqTrHkZvnL9DJKn+Twmt0NsGGHZy2Dn3kQYfsQ53Hh4/r4RNGz8AIpdzKEuaAF0RC2E57MmQgE3ATjuM/CPiANW7AqSfQJQ5vk362eQKmd3JrmXsoSRocpNIMnbB9zbceDIWUPmuHFQNMkISqa9DpUvNK6YDpW2s8DfwBK48WFQnhMCgzUBoLy0BrRVe5P0NWjPLdKUsJiR1tR1wGp8IeZwMgx/SrgRvjxuAziNcwLvyathLOcJHLflhRDYGRYFrNET2rJ5yvPLoas0tOj/oL8UpC4JHyTSU+6MNCS4gvKoAB5WiKG+MAQSg0WwLXQ/ZJ3xhao0FxB5hYCbUwAEfhEF3Td8QP2dAOQnPwFlxgrolUVq9TPoaX+ZB2nLc2Gk6awj1MU78HZZwJMid2Byb550JQwVO0NfxlJgdz14vWKeRAiK6DlQF28PLZdcoLNcBIO92bb6GTQ8Q/13RURT6tlH2gvXMlITLYD6uI+gp2ozdF0VQXumM6ivCqGvahM8kPiDItkeGo8tB025GFQ3xFrSr06zI3/4yde7oN7m0sWk5eKWDqK5JWJQvAHac9ygq3Adr9gTNNc3QG85rzPfHe5/7wDtPwuhp/Zz6CjyhaZzwi6ivfetHdH/oP77+3PJQOsuRnqkQdCa4wWqyx6gyecpL64GTaEX7ycXUJz4GJp1B4O0X/Hg0Xp1tFV+8Ei1k6c5coHofxBrrzQinbKYo0SVJ+wn6iurGHlY5gY911aDJnMFaHXXiDp9GQyvtKfUA9QFTtBZ7gPdit0tpFd9OpwwFmlA9D/o9yNLDpxIKmI8PMnNSNtviCLVpYTITzrXEGWaq4qos0WgOPdpCenIF+eRrurjB4k0PXopYZG6gMg/D/gNBUxhAbSAmKMAAAAASUVORK5CYII="/>川公网安备51019002006052</a>
              </span>
                <!-- 版权所有 | 法律声明 | 隐私保护 -->
            </p>
            <p class="footer-message" style="font-size: 14px;">
                <span style="margin-right: 20px"><i class="fa fa-fax"
                                                    style="margin-right: 10px"></i> 028 82880293</span>
                <span><i class="fa fa-map-marker" style="margin-right: 10px"></i>成都市高新区天府大道中段530号东方希望天祥广场A栋3005</span>
            </p>
        </div>
    </footer>
</template>
<script>
    export default {
        name: "Footer",
        data: function () {
            return {
                copyright:"",
            }
        },
        created: function(){
            this.copyright = this.getYear();
        },
        methods: {
            getYear: function () {
                return   "成都鱼住未来科技有限公司版权所有 ©2019 - " + new Date().getFullYear()
            }
        }
    }
</script>
